// extracted by mini-css-extract-plugin
export default {"Circle1":"Circle1_Circle1__0msyb"};